module.exports = __webpack_public_path__ + "static/coastalreign-logo-68eb04b928e9d0ed076fb0d07ac5f868.png";